import axios from 'axios';
import Cookies from 'js-cookie';
import {
  fetchCartStart,
  fetchCartSuccess,
  fetchCartFailure,
  addToCartSuccess,
  removeFromCartSuccess,
  clearCartSuccess,
  updateCartItemQuantity
} from '../slices/cartSlice';

// export const fetchCart = () => async (dispatch) => {
//   try {
//     dispatch(fetchCartStart());

//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.get(
//       'https://seller-backend-29o9.onrender.com/api/buyer/get-cart',
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     const cartItems = response.data.cart.items || [];

//     let totalItems = 0;
//     let totalPrice = 0;

//     const formattedItems = cartItems.map((item) => {
//       const total = item.price * item.quantity;
//       totalItems += item.quantity;
//       totalPrice += total;

//       return {
//         productId: item?.productId._id,
//         variantId: item?.variantId || null,
//         sellerId: item?.sellerId,
//         name: item?.productId?.name,
//         variantName: item?.variantId?.name || null,
//         quantity: item?.quantity,
//         price: item?.price,
//         total,
//       };
//     });

//     const formattedCart = {
//       items: formattedItems,
//       loading: false,
//       error: null,
//       totalItems,
//       totalPrice,
//     };

//     dispatch(fetchCartSuccess(formattedCart));
//   } catch (error) {
//     dispatch(fetchCartFailure(error.message));
//   }
// };

export const fetchCart = () => async (dispatch) => {
  try {
    dispatch(fetchCartStart());

    const token = Cookies.get('ecom_user_token');
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/buyer/get-cart`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const cartItems = response.data.cart.items || [];

    let totalItems = 0;
    let totalPrice = 0;

    const formattedItems = cartItems.map((item) => {
      const total = item.price * item.quantity;
      totalItems += item.quantity;
      totalPrice += total;

      return {
        productId: item?.productId._id,
        variantId: item?.variantId || null,
        image: item?.image,
        sellerId: item?.sellerId,
        name: item?.productId?.name,
        variantName: item?.variantId?.name || null,
        quantity: item?.quantity,
        price: item?.price,
        total,
      };
    });

    const formattedCart = {
      items: formattedItems,
      loading: false,
      error: null,
      totalItems,
      totalPrice,
    };

    dispatch(fetchCartSuccess(formattedCart));
  } catch (error) {
    if (error.response && error.response.status === 404) {
      // If cart not found (404), dispatch success with empty cart
      const emptyCart = {
        items: [],
        loading: false,
        error: null,
        totalItems: 0,
        totalPrice: 0,
      };
      dispatch(fetchCartSuccess(emptyCart));
    } else {
      // For other errors, dispatch failure
      dispatch(fetchCartFailure(error.message));
    }
  }
};

export const addToCart = ({productId, variantId, quantity}) => async (dispatch) => {
  try {
    const token = Cookies.get('ecom_user_token');
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/buyer/add-to-cart`,
      { productId, variantId, quantity },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    const updatedItem = response.data.cart.items.find(
      item => item.productId === productId && 
             (variantId ? item.variantId === variantId : true)
    );
    
    if (updatedItem) {
      const formattedItem = {
        ...updatedItem,
        productId: updatedItem.productId,
        variantId: updatedItem.variantId || null,
        variantName: updatedItem.variantId?.name || null,
        quantity: updatedItem.quantity,
      };
      dispatch(addToCartSuccess(formattedItem));
    } else {
      dispatch(removeFromCartSuccess({ productId, variantId }));
    }
    
  } catch (error) {
    console.error('Error adding to cart:', error);
    throw error;
  }
};

export const removeFromCart = ({productId, variantId}) => async (dispatch) => {
  try {
    console.log("ravi raj product id",productId)
        console.log("ravi raj variant id",variantId)

    const token = Cookies.get('ecom_user_token');
    await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/api/buyer/remove-from-cart`,
      { productId, variantId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    );
    
    dispatch(removeFromCartSuccess({ productId, variantId }));
  } catch (error) {
    console.error('Error removing from cart:', error);
    throw error;
  }
};

export const clearCart = () => async (dispatch) => {
  try {
    const token = Cookies.get('ecom_user_token');
    const cartResponse = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/buyer/get-cart`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    const removePromises = cartResponse.data.cart.items.map(item =>
      axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/buyer/remove-from-cart`,
        { 
          productId: item.productId._id,
          variantId: item.variantId?._id 
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
    );
    
    await Promise.all(removePromises);
    dispatch(clearCartSuccess());
    
  } catch (error) {
    console.error('Error clearing cart:', error);
    throw error;
  }
};

export const updateItemQuantity = ({productId, variantId, quantity}) => async (dispatch) => {
  try {
    const token = Cookies.get('ecom_user_token');
    
    if (quantity <= 0) {
      // Remove item if quantity is 0 or less
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/buyer/remove-from-cart`,
        { productId, variantId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      dispatch(removeFromCartSuccess({ productId, variantId }));
    } else {
      // Optimistically update UI first
      dispatch(updateCartItemQuantity({ productId, variantId, quantity }));
      
      // Then sync with server
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/buyer/add-to-cart`,
        { productId, variantId, quantity },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }
    
  } catch (error) {
    console.error('Error updating quantity:', error);
    dispatch(fetchCart()); // Refresh cart to sync with server
    throw error;
  }
};

// import axios from 'axios';
// import Cookies from 'js-cookie';
// import {
//   fetchCartStart,
//   fetchCartSuccess,
//   fetchCartFailure,
//   addToCartSuccess,
//   removeFromCartSuccess,
//   clearCartSuccess,
//   updateCartItemQuantity
// } from '../slices/cartSlice';

// export const fetchCart = () => async (dispatch) => {
//   try {
//     dispatch(fetchCartStart());

//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.get(
//       'https://seller-backend-29o9.onrender.com/api/buyer/get-cart',
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     const cartItems = response.data.cart.items || [];

//     let totalItems = 0;
//     let totalPrice = 0;

//     const formattedItems = cartItems.map((item) => {
//       const total = item.price * item.quantity;
//       totalItems += item.quantity;
//       totalPrice += total;

//       return {
//         productId: item?.productId._id,
//         sellerId: item?.sellerId,
//         name: item.productId?.name,
//         quantity: item?.quantity,
//         price: item?.price,
//         total,
//       };
//     });

//     const formattedCart = {
//       items: formattedItems,
//       loading: false,
//       error: null,
//       totalItems,
//       totalPrice,
//     };

//     dispatch(fetchCartSuccess(formattedCart));
//   } catch (error) {
//     dispatch(fetchCartFailure(error.message));
//   }
// };

// export const addToCart = ({productId, quantity}) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.post(
//       'https://seller-backend-29o9.onrender.com/api/buyer/add-to-cart',
//       { productId, quantity },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
    
//     const updatedItem = response.data.cart.items.find(
//       item => item.productId === productId
//     );
    
//     if (updatedItem) {
//       dispatch(addToCartSuccess(updatedItem));
//     } else {
//       dispatch(removeFromCartSuccess(productId));
//     }
    
//   } catch (error) {
//     console.error('Error adding to cart:', error);
//     throw error;
//   }
// };

// export const removeFromCart = (productId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     await axios.patch(
//       'https://seller-backend-29o9.onrender.com/api/buyer/remove-from-cart',
//       { productId },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         }
//       }
//     );
    
//     dispatch(removeFromCartSuccess(productId));
//   } catch (error) {
//     console.error('Error removing from cart:', error);
//     throw error;
//   }
// };

// export const clearCart = () => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     const cartResponse = await axios.get(
//       'https://seller-backend-29o9.onrender.com/api/buyer/get-cart',
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
    
//     const removePromises = cartResponse.data.cart.items.map(item =>
//       axios.patch(
//         'https://seller-backend-29o9.onrender.com/api/buyer/remove-from-cart',
//         { productId: item.productId._id },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//     );
    
//     await Promise.all(removePromises);
//     dispatch(clearCartSuccess());
    
//   } catch (error) {
//     console.error('Error clearing cart:', error);
//     throw error;
//   }
// };

// export const updateItemQuantity = ({productId, quantity}) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
    
//     if (quantity <= 0) {
//       // Remove item if quantity is 0 or less
//       await axios.patch(
//         'https://seller-backend-29o9.onrender.com/api/buyer/remove-from-cart',
//         { productId },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           }
//         }
//       );
//       dispatch(removeFromCartSuccess(productId));
//     } else {
//       // Optimistically update UI first
//       dispatch(updateCartItemQuantity({ productId, quantity }));
      
//       // Then sync with server
//       await axios.post(
//         'https://seller-backend-29o9.onrender.com/api/buyer/add-to-cart',
//         { productId, quantity },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//     }
    
//   } catch (error) {
//     console.error('Error updating quantity:', error);
//     dispatch(fetchCart());
//     throw error;
//   }
// };

// // src/redux/thunks/cartThunks.js
// import axios from 'axios';
// import Cookies from 'js-cookie';
// import {
//   fetchCartStart,
//   fetchCartSuccess,
//   fetchCartFailure,
//   addToCartSuccess,
//   removeFromCartSuccess,
//   clearCartSuccess,
//   updateCartItemQuantity
// } from '../slices/cartSlice';

// // export const fetchCart = () => async (dispatch) => {
// //   try {
// //     dispatch(fetchCartStart());
// //     const token = Cookies.get('ecom_user_token');
// //     const response = await axios.get(
// //       'https://seller-backend-29o9.onrender.com/api/buyer/get-cart',
// //       {
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //         },
// //       }
// //     );
    
// //     dispatch(fetchCartSuccess(response.data.cart));
// //   } catch (error) {
// //     dispatch(fetchCartFailure(error.message));
// //   }
// // };

// export const fetchCart = () => async (dispatch) => {
//   try {
//     dispatch(fetchCartStart());

//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.get(
//       'https://seller-backend-29o9.onrender.com/api/buyer/get-cart',
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     const cartItems = response.data.cart.items || [];

//     let totalItems = 0;
//     let totalPrice = 0;

//     const formattedItems = cartItems.map((item) => {
//       const total = item.price * item.quantity;
//       totalItems += item.quantity;
//       totalPrice += total;

//       return {
//         productId: item.productId._id,
//         sellerId: item.sellerId,
//         quantity: item.quantity,
//         price: item.price,
//         total,
//       };
//     });

//     const formattedCart = {
//       items: formattedItems,
//       loading: false,
//       error: null,
//       totalItems,
//       totalPrice,
//     };

//     dispatch(fetchCartSuccess(formattedCart));
//   } catch (error) {
//     dispatch(fetchCartFailure(error.message));
//   }
// };

// export const addToCart = ({productId, quantity}) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     const response = await axios.post(
//       'https://seller-backend-29o9.onrender.com/api/buyer/add-to-cart',
//       { productId, quantity },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
    
//     // Update the specific item in the cart
//     const updatedItem = response.data.cart.items.find(
//       item => item.productId === productId
//     );
    
//     if (updatedItem) {
//       dispatch(addToCartSuccess(updatedItem));
//     } else {
//       // If the item was removed (quantity set to 0)
//       dispatch(removeFromCartSuccess(productId));
//     }
    
//   } catch (error) {
//     console.error('Error adding to cart:', error);
//     throw error; // Re-throw to handle in component
//   }
// };

// export const removeFromCart = (productId) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     await axios.patch(
//       'https://seller-backend-29o9.onrender.com/api/buyer/remove-from-cart',
//       { productId },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         }
//       }
//     );
    
//     dispatch(removeFromCartSuccess(productId));
//   } catch (error) {
//     console.error('Error removing from cart:', error);
//     throw error;
//   }
// };

// export const clearCart = () => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
//     // First get current cart items
//     const cartResponse = await axios.get(
//       'https://seller-backend-29o9.onrender.com/api/buyer/get-cart',
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
    
//     // Remove all items one by one
//     const removePromises = cartResponse.data.cart.items.map(item =>
//       axios.patch(
//         'https://seller-backend-29o9.onrender.com/api/buyer/remove-from-cart',
//         { productId: item.productId._id },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//     );
    
//     await Promise.all(removePromises);
//     dispatch(clearCartSuccess());
    
//   } catch (error) {
//     console.error('Error clearing cart:', error);
//     throw error;
//   }
// };

// // export const updateItemQuantity = ({productId, quantity}) => async (dispatch) => {
// //   try {
// //     console.log("")
// //     // Optimistically update the UI
// //     dispatch(updateCartItemQuantity({ productId, quantity }));
    
// //     // Then sync with the server
// //     const token = Cookies.get('ecom_user_token');
// //     await axios.post(
// //       'https://seller-backend-29o9.onrender.com/api/buyer/add-to-cart',
// //       { productId, quantity },
// //       {
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //         },
// //       }
// //     );
    
// //   } catch (error) {
// //     console.error('Error updating quantity:', error);
// //     // On error, refetch the cart to sync with server
// //     dispatch(fetchCart());
// //     throw error;
// //   }
// // };
// export const updateItemQuantity = ({productId, quantity}) => async (dispatch) => {
//   try {
//     const token = Cookies.get('ecom_user_token');
    
//     if (quantity <= 0) {
//       // If quantity is 0 or less, remove the item completely
//       await axios.patch(
//         'https://seller-backend-29o9.onrender.com/api/buyer/remove-from-cart',
//         { productId },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           }
//         }
//       );
//       dispatch(removeFromCartSuccess(productId));
//     } else {
//       // Optimistically update the UI first for better responsiveness
//       dispatch(updateCartItemQuantity({ productId, quantity }));
      
//       // Then sync with the server
//       await axios.post(
//         'https://seller-backend-29o9.onrender.com/api/buyer/add-to-cart',
//         { productId, quantity },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//     }
    
//   } catch (error) {
//     console.error('Error updating quantity:', error);
//     // On error, refetch the cart to sync with server
//     dispatch(fetchCart());
//     throw error;
//   }
// };